import { render, staticRenderFns } from "./CustomNavigation.vue?vue&type=template&id=e2c0b6b2&scoped=true&"
import script from "./CustomNavigation.vue?vue&type=script&lang=js&"
export * from "./CustomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CustomNavigation.vue?vue&type=style&index=0&id=e2c0b6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c0b6b2",
  null
  
)

export default component.exports